import type { ReactNode } from 'react';

export interface AccordionItem {
  /** Kurze Frage oder Überschrift, die immer sichtbar ist. */
  question: string;
  answer: ReactNode;
  /** Beim ersten Anzeigen aufgeklappt (z. B. die erste Gruppe der Berichte). */
  open?: boolean;
}

/**
 * Ein- und ausklappbare Liste („Akkordeon“), etwa für häufige Fragen. Baut auf `<details>`/`<summary>`
 * auf: per Tastatur bedienbar, ohne JavaScript, und Screenreader melden „ausgeklappt“/„eingeklappt“.
 */
export function Accordion({ items }: { items: readonly AccordionItem[] }) {
  return (
    <div className="accordion">
      {items.map((item) => (
        <details key={item.question} className="accordion__item" open={item.open}>
          <summary className="accordion__summary">
            <span>{item.question}</span>
            <span className="accordion__chevron" aria-hidden="true" />
          </summary>
          <div className="accordion__body">{item.answer}</div>
        </details>
      ))}
    </div>
  );
}
